export default {
  props: {
    source: {
      type: Function
    },
    state: {
      type: Object,
      default: () => ({ sort: {}, pagination: {} })
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    sortBy: {
      type: String,
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
  },


  data () {
    return {
      result: [],
      loading: false,
      footer: {
        'items-per-page-text': this.$t('shared.table.rows-per-page'),
        'items-per-page-options': [25, 50, 100, { text: this.$t('shared.table.all'), value: -1 }],
      },
      labels: {
        nodata: this.$t('shared.table.no-data-available'),
      },
      sortRules: {},
      options: null
    }
  },

  computed: {
    _items () {
      return (this.result || []).items || this.result || []
    },

    _total () {
      return (this.result || []).total || -1
    }
  },

  methods: {
    async refresh (reset = true) {
      this.loading = true

      if (reset)
        this.options.page = 1

      const sortKey = this.options.sortBy[0]
      const column = this.sortRules && this.sortRules[sortKey] ? this.sortRules[sortKey] : sortKey

      const args = {
        sort: { column: column, desc: !!this.options.sortDesc[0] },
        pagination: { limit: this.options.itemsPerPage, page: this.options.page }
      }

      this.$emit('change', args)
      this.result = await Promise.resolve(this.source(args))
      this.$emit('ready', args)

      this.loading = false
    },

    sortByRule (value) {
      const rules = this.sortRules || {}
      return Object.keys(rules).find(key => rules[key] === value) || value
    }
  },

  created () {
    this.options = {
      page: this.state.pagination.page || this.page,
      itemsPerPage: this.state.pagination.limit || this.pageSize,
      sortBy: [ this.sortByRule(this.state.sort.column || this.sortBy) ],
      sortDesc: [ this.state.sort.desc || this.sortDesc ],
    }
  },

  watch: {
    options () {
      this.refresh(false)
    }
  }
}